import { message } from 'antd'; // Import Ant Design's message component

// Helper to get the cart from localStorage
const getCart = () => {
    let cart = localStorage.getItem('cart');
    return cart ? JSON.parse(cart) : [];
};

// Helper to save the cart to localStorage
const saveCart = (cart) => {
    localStorage.setItem('cart', JSON.stringify(cart));
    // Dispatch a custom event whenever the cart is updated
    const cartUpdatedEvent = new Event('cartUpdated');
    window.dispatchEvent(cartUpdatedEvent); // Dispatch the event to notify other components
};

// Update an item in the cart
const updateCartItem = (id, newQty) => {
    let cart = getCart();
    let item = cart.find(item => item.id === id);
    if (item) {
        item.qty = newQty;
        saveCart(cart);
        message.success(`Item updated in the cart.`);
    } else {
        message.error(`Item not found in the cart.`);
    }
};

// Add an item to the cart
const addToCart = (id, qty) => {
    let cart = getCart();
    let item = cart.find(item => item.id === id);

    if (item) {
        // If item exists, update its quantity
        updateCartItem(id, item.qty + qty);
    } else {
        // If item does not exist, add it to the cart
        cart.push({ id, qty });
        saveCart(cart);
        message.success(`Item added to the cart.`);
    }
};

// Remove an item from the cart
const removeFromCart = (id) => {
    let cart = getCart();
    cart = cart.filter(item => item.id !== id);
    saveCart(cart);
    message.info(`Item removed from the cart.`);
};

export { getCart, saveCart, addToCart, updateCartItem, removeFromCart };
